import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
    type: string;
}
export const useDeletePaymentOption = ({ customerId, type }: IProps) => useMutation(
  'DeletePaymentOption',
  async () => {
    const { data } = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/paymentOptions/${type}`);
    return data;
  },
  { retry: 1 },
);
